import { render, staticRenderFns } from "./OxygenTabsAndControls.vue?vue&type=template&id=6811b898&"
import script from "./OxygenTabsAndControls.vue?vue&type=script&lang=ts&"
export * from "./OxygenTabsAndControls.vue?vue&type=script&lang=ts&"
import style0 from "./OxygenTabsAndControls.vue?vue&type=style&index=0&id=6811b898&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports